export default "__VITE_ASSET__vCkOTxud__"